// extracted by mini-css-extract-plugin
export default {"root":"ImageFromFile_root__aUdt5","aspectWrapper":"ImageFromFile_aspectWrapper__I4sTm","rootForImage":"ImageFromFile_rootForImage__uZb39"};